export function Hero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          End-to-End Solutions
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          System Integration & Custom Development
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          We bridge the gap between your systems and technologies. As expert system integrators, 
          we seamlessly connect ERP systems with third-party applications, legacy systems, 
          weigh bridges, financial institutions (M-Pesa, banks, fintech), and more. Plus, 
          we develop custom software solutions—mobile apps, web systems, and desktop applications— 
          leveraging the latest technologies and AI agents to drive your digital transformation.
        </p>
        
      </div>
      <div className="flex-1">
        <img
          src="/images/integrationImg/system-integration.png"
          alt="System Integration Architecture"
          className="w-72 mx-auto shadow-lg rounded-lg"
        />
      </div>
    </section>
  );
}